module.exports = __webpack_public_path__ + "img/logo-adhiguna-putra.c3a42163.png";